import { useEffect } from "react";
import { TooltipProvider } from "@/components/ui/tooltip";
import { useClinicSettings } from "@/lib/store/clinic-settings";

export function AppProvider({ children }: { children: React.ReactNode }) {
  const { theme } = useClinicSettings();

  useEffect(() => {
    const root = window.document.documentElement;
    root.classList.remove("light", "dark");
    root.classList.add(theme);
  }, [theme]);

  return (
    <TooltipProvider>
      {children}
    </TooltipProvider>
  );
}
